"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawTxb = withdrawTxb;
exports.coinAmountToXTokensSingleAsset = coinAmountToXTokensSingleAsset;
exports.coinAmountToXTokensDoubleAsset = coinAmountToXTokensDoubleAsset;
const transactions_1 = require("@mysten/sui/transactions");
const maps_js_1 = require("../common/maps.js");
const cetus_js_1 = require("./cetus.js");
const bluefin_js_1 = require("./bluefin.js");
const navi_js_1 = require("./navi.js");
const bucket_js_1 = require("./bucket.js");
const getReceipts_js_1 = require("../sui-sdk/functions/getReceipts.js");
const navi_looping_js_1 = require("./navi-looping.js");
const deposit_js_1 = require("./deposit.js");
const alphalend_js_1 = require("./alphalend.js");
const decimal_js_1 = require("decimal.js");
async function withdrawTxb(xTokensAmount, poolName, address) {
    let txb = new transactions_1.Transaction();
    if (maps_js_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        const coin1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
        if (coin1 === "CETUS" && coin2 === "SUI") {
            txb = await (0, cetus_js_1.withdrawCetusSuiTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin2 === "SUI") {
            txb = await (0, cetus_js_1.withdrawCetusAlphaSuiTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else {
            txb = await (0, cetus_js_1.withdrawCetusTxb)(xTokensAmount, poolName, {
                address,
            });
        }
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
        const coin1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
        if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb = await (0, bluefin_js_1.withdrawBluefinFungibleTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI" ||
            poolName === "BLUEFIN-ALPHA-USDC" ||
            poolName === "BLUEFIN-BLUE-USDC") {
            txb = await (0, bluefin_js_1.withdrawBluefinType2Txb)(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin1 === "SUI") {
            txb = await (0, bluefin_js_1.withdrawBluefinSuiFirstTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin2 === "SUI") {
            txb = await (0, bluefin_js_1.withdrawBluefinSuiSecondTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else if (coin1 === "STSUI" || coin2 === "STSUI") {
            txb = await (0, bluefin_js_1.withdrawBluefinStsuiTxb)(xTokensAmount, poolName, {
                address,
            });
        }
        else {
            txb = await (0, bluefin_js_1.withdrawBluefinType1Txb)(xTokensAmount, poolName, {
                address,
            });
        }
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "NAVI") {
        if (maps_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            txb = await (0, navi_looping_js_1.loopingWithdraw)(poolName, xTokensAmount, { address });
        }
        else
            txb = await (0, navi_js_1.naviWithdrawTx)(xTokensAmount, poolName, { address });
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "BUCKET") {
        txb = await (0, bucket_js_1.bucketWithdrawTx)(xTokensAmount, { address });
    }
    else if (maps_js_1.poolInfo[poolName].parentProtocolName === "ALPHALEND") {
        if (maps_js_1.poolInfo[poolName].strategyType === "LOOPING") {
            txb = await (0, alphalend_js_1.alphalendLoopingWithdraw)(poolName, xTokensAmount, {
                address,
            });
        }
        else if (maps_js_1.poolInfo[poolName].strategyType === "SINGLE-LOOPING") {
            txb = await (0, alphalend_js_1.alphalendSingleLoopWithdraw)(poolName, xTokensAmount, {
                address: address,
            });
        }
    }
    txb.setSender(address);
    const estimatedGasBudget = await (0, deposit_js_1.getEstimatedGasBudget)(txb, address);
    if (estimatedGasBudget)
        txb.setGasBudget(estimatedGasBudget);
    return txb;
}
async function coinAmountToXTokensSingleAsset(amount, poolName) {
    const exchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, true);
    const xTokens = Math.floor(parseFloat(amount) / exchangeRate.toNumber());
    return xTokens.toString();
}
async function coinAmountToXTokensDoubleAsset(amount, poolName, isAmountA) {
    const liquidity = await (0, deposit_js_1.getLiquidity)(poolName, isAmountA, amount);
    let liquidityAmount = liquidity.liquidityAmount.toString();
    if (maps_js_1.poolInfo[poolName].strategyType === "LEVERAGE-YIELD-FARMING") {
        let investor = (await (0, getReceipts_js_1.getInvestor)(poolName, true));
        liquidityAmount = new decimal_js_1.Decimal(liquidityAmount)
            .div(new decimal_js_1.Decimal(1).minus(new decimal_js_1.Decimal(investor.content.fields.current_debt_to_supply_ratio.fields.value).div(1e18)))
            .toString();
    }
    const exchangeRate = await (0, getReceipts_js_1.getPoolExchangeRate)(poolName, true);
    let xTokens = new decimal_js_1.Decimal(liquidityAmount).div(exchangeRate);
    return xTokens.floor().toString();
}
//# sourceMappingURL=withdraw.js.map